import { chakra, Stack, Text } from '@chakra-ui/react';
import type { IndexedPageFootnote } from 'hooks/usePageFootnotes';

import { DisclaimerBox } from './DisclaimerBox';
import type { DisclaimerContent } from './useDisclaimers';

type DisclaimersProps = {
  disclaimers: DisclaimerContent | null;
  pageFootnotes: IndexedPageFootnote[];
};

export const Disclaimers = ({
  disclaimers,
  pageFootnotes,
}: DisclaimersProps) => {
  if (!disclaimers && pageFootnotes.length === 0) return null;

  return (
    <Stack gap="5xs">
      {disclaimers && (
        <DisclaimerBox>
          <Text size="detail" color="gray.600" fontWeight="medium">
            {disclaimers.fdaDisclaimer}
          </Text>
        </DisclaimerBox>
      )}
      <DisclaimerBox gap="5xs">
        {disclaimers && (
          <Text size="detail" color="blackAlpha.700">
            {disclaimers.references}
          </Text>
        )}
        {pageFootnotes.map(({ footnote, index: footnoteIdx }) => {
          const id = `footnote-${footnoteIdx}`;
          return (
            <Text key={id} id={id} size="detail" color="blackAlpha.700">
              <chakra.span
                width="xs"
                display="inline-block"
                sx={{
                  fontVariantNumeric: 'lining-nums tabular-nums',
                }}
              >
                {footnoteIdx}.
              </chakra.span>
              {footnote.content}
            </Text>
          );
        })}
      </DisclaimerBox>
    </Stack>
  );
};
